<template>
  <div class="select-wrapper " v-if="governorateLength > 0">
    <select class="custom-select" name="options" v-model="__modelValue" required :class="{ has_error: invalid }">
      <option :value="emptyValue" disabled selected>{{ $_getTranslations.common_form_input_select_governorate }}</option>
      <option
        v-for="govItem in options"
        :key="govItem.id"
        :value="govItem.value"
      >{{ govItem.text }}</option>
    </select>
    <i class="fa fa-angle-down custom-icon"></i>
  </div>
</template>

<script>
import translationMixin from "../../../common/mixins/translation";
import {governorateEnum, governorateTranslationMap} from "../../../constants/governorate";
import {mapState} from "vuex";

export default {
  name: 'GovernorateSelection',
  emits: ['update:modelValue'],
  mixins: [
    translationMixin
  ],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    emptyValue: {
      type: [String, Object],
      default: ''
    },
    invalid: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    getGovValue(index) {
      return governorateEnum[`GOV_${index}`]
    },
    getGovText(value) {
      return this.$_getTranslations[governorateTranslationMap[value]]
    }
  },
  computed: {
    __modelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    options() {
      return [...Array(this.governorateLength).keys()].map(index => {
        const id = index + 1
        const value = this.getGovValue(id)

        return { id, value, text: this.getGovText(value) }
      })
    },
    ...mapState('common', [
      'governorateLength'
    ])
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/formInput/GovernorateSelection.vue